import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import multimediaSVG from '@plone/volto/icons/slider.svg';
import MultimediaView from 'iovisit-theme/components/Blocks/Multimedia/View';
import MultimediaEdit from 'iovisit-theme/components/Blocks/Multimedia/Edit';
import MultimediaFolderGalleryView from 'iovisit-theme/components/Blocks/MultimediaFolderGallery/View';
import MultimediaFolderGalleryEdit from 'iovisit-theme/components/Blocks/MultimediaFolderGallery/Edit';
import CardsVariation from 'iovisit-theme/components/Blocks/Listing/CardsTemplate/Cards';
import SliderVariation from 'iovisit-theme/components/Blocks/Listing/Slider/Slider';
import LinkCardVariation from 'iovisit-theme/components/Blocks/Listing/LinkCard';
import LinkInEvidenceVariation from 'iovisit-theme/components/Blocks/Listing/LinkInEvidence';
import MapTemplate from 'iovisit-theme/components/Blocks/Listing/MapTemplate';
import BreakView from 'iovisit-theme/components/Blocks/Break/View';
import BreakEdit from 'iovisit-theme/components/Blocks/Break/Edit';
import divideHorizontalSVG from '@plone/volto/icons/divide-horizontal.svg';
import ContactsView from 'iovisit-theme/components/Blocks/Contacts/View';
import ContactsEdit from 'iovisit-theme/components/Blocks/Contacts/Edit';
import globeSVG from '@plone/volto/icons/globe.svg';
import zoomSVG from '@plone/volto/icons/zoom.svg';
import ViewSearchEvents from 'iovisit-theme/components/Blocks/SearchEvents/View';
import EditSearchEvents from 'iovisit-theme/components/Blocks/SearchEvents/Edit';
import ViewSearchStrutturaRicettiva from 'iovisit-theme/components/Blocks/SearchStrutturaRicettiva/View';
import EditSearchStrutturaRicettiva from 'iovisit-theme/components/Blocks/SearchStrutturaRicettiva/Edit';
import ViewHeroImageLeftBlock from 'iovisit-theme/customizations/volto/components/manage/Blocks/HeroImageLeft/View';
import EditHeroImageLeftBlock from 'iovisit-theme/customizations/volto/components/manage/Blocks/HeroImageLeft/Edit';
import HeroImageLeftBlockSchema from 'iovisit-theme/customizations/volto/components/manage/Blocks/HeroImageLeft/schema';
import heroSVG from '@plone/volto/icons/hero.svg';
import countDownSVG from '@plone/volto/icons/chrono.svg';
import CountDownBlockView from 'iovisit-theme/components/Blocks/CountDown/View';
import CountDownBlockEdit from 'iovisit-theme/components/Blocks/CountDown/Edit';

import {
  getDefaultSchema,
  getSliderVariationSchema,
  getCardsVariationSchema,
  getMapVariationSchema,
  removeListingVariation,
} from 'iovisit-theme/config';

export const IoVisitBlocks = (config) => {
  const customBlocksOrder = [{ id: 'search', title: 'Ricerca' }];

  config.blocks.groupBlocksOrder = config.blocks.groupBlocksOrder.concat(
    customBlocksOrder,
  );
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    break: {
      id: 'break',
      title: 'Interruzione di pagina',
      icon: divideHorizontalSVG,
      group: 'text',
      view: BreakView,
      edit: BreakEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 0,
    },

    hero: {
      id: 'hero',
      title: 'Hero',
      icon: heroSVG,
      group: 'common',
      view: ViewHeroImageLeftBlock,
      edit: EditHeroImageLeftBlock,
      schema: BlockSettingsSchema,
      blockSchema: HeroImageLeftBlockSchema,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: true,
      sidebarTab: 1,
    },

    multimedia: {
      id: 'multimedia',
      title: 'Multi media',
      icon: multimediaSVG,
      group: 'media',
      view: MultimediaView,
      edit: MultimediaEdit,
      restricted: false,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    multimediaFolderGallery: {
      //mostra (in formato gallery) il contenuto della cartella Multimedia presente fra gli items del ct
      id: 'multimediaFolderGallery',
      title: 'Multimedia Folder Gallery',
      icon: multimediaSVG,
      group: 'media',
      view: MultimediaFolderGalleryView,
      edit: MultimediaFolderGalleryEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    contacts: {
      id: 'contacts',
      title: 'Contatti con mappa',
      icon: globeSVG,
      group: 'text',
      view: ContactsView,
      edit: ContactsEdit,
      restricted: true,
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    count_down: {
      id: 'count_down',
      title: 'Count Down',
      icon: countDownSVG,
      group: 'common',
      view: CountDownBlockView,
      edit: CountDownBlockEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    searchStrutturaRicettiva: {
      id: 'searchStrutturaRicettiva',
      title: 'Ricerca strutture ricettive',
      icon: zoomSVG,
      group: 'search',
      view: ViewSearchStrutturaRicettiva,
      edit: EditSearchStrutturaRicettiva,
      restricted: false,
      mostUsed: true,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    searchEvents: {
      id: 'searchEvents',
      title: 'Ricerca eventi',
      icon: zoomSVG,
      group: 'search',
      view: ViewSearchEvents,
      edit: EditSearchEvents,
      restricted: false,
      mostUsed: true,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    listing: {
      ...config.blocks.blocksConfig.listing,
      showLinkMore: true,
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'cards',
          isDefault: true,
          title: 'Cards',
          template: CardsVariation,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getCardsVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'slider',
          isDefault: false,
          title: 'Slider',
          template: SliderVariation,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getSliderVariationSchema(schema, formData, intl, pos);
            return schema;
          },
        },
        {
          id: 'link-card',
          isDefault: false,
          title: 'Link card',
          template: LinkCardVariation,
          schemaEnhancer: ({ schema, formData, intl }) => {
            getDefaultSchema(schema, formData, intl);

            return schema;
          },
        },
        {
          id: 'link-in-evidence',
          isDefault: false,
          title: 'Link in evidenza',
          template: LinkInEvidenceVariation,
          schemaEnhancer: ({ schema, formData, intl }) => {
            getDefaultSchema(schema, formData, intl);

            return schema;
          },
        },
        {
          id: 'map-template',
          isDefault: false,
          title: 'Mappa',
          template: MapTemplate,
          schemaEnhancer: ({ schema, formData, intl }) => {
            let pos = getDefaultSchema(schema, formData, intl);
            getMapVariationSchema(schema, formData, intl, pos);

            return schema;
          },
        },
      ],
    },
  };

  config.blocks.requiredBlocks = ['multimediaFolderGallery', 'contacts'];
  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    PointOfInterest: ['title', 'text', 'multimediaFolderGallery', 'contacts'],
    Event: ['title', 'text', 'contacts'],
  };

  //remove Volto's blocks and variations
  delete config.blocks.blocksConfig.search; //disabilitato momentaneamente il blocco search 'faccette'
  delete config.blocks.blocksConfig.leadimage; //rimosso perchè non servere per io-visit
  removeListingVariation(config, 'default'); // removes default volto template, because it will be overrided
  removeListingVariation(config, 'imageGallery'); // removes imageGallery template because we have slider template
  removeListingVariation(config, 'summary'); // removes summary template because we don't need it
};
